<template>
    <section class="sell_in_bulk_section3" id="custom-quote">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="row">
            <div class="col-12 col-md-10 offset-md-1 col-lg-7 offset-lg-3">
                <h3 class="text-center" style="margin: 0 auto 2%;color: #555; font-weight: 400; font-size: 2.25rem;"><strong style="color: #02B514; font-weight: 600;"> {{ cmsData[0].form_title }}</strong></h3>
                <h5 class="text-center" style="color: #6f6f6f; font-size: 1.15rem; font-weight: 600;">
                    {{ cmsData[0].form_sub_title }}
                </h5>
                <div class="bot-pad">&nbsp;</div>
                <section class="form_section">
                    <ul class="nav flex-column flex-sm-row nav-pills mb-4 border bg-white" id="pills-tab" role="tablist" style="background-color: #f1f1f1;">
                        <li class="nav-text w-100 text-center">
                            {{ cmsData[0].form_header }}
                            <hr class="mt-1 mb-1">
                        </li>
                        <li class="nav-item  justify-content-center align-items-center" role="presentation">
                            <a v-on:click="type='formData'" class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false"> {{ cmsData[0].form_left_side_menu_text }} </a>
                        </li>
                        <li class="nav-item justify-content-center align-items-center" role="presentation">
                            <a v-on:click="type='uploadFile'" class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false"> {{ cmsData[0].form_right_side_menu_text }} </a>
                        </li>
                    </ul>
                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                            <fieldset class="bg-white" v-for="(input, index) in productDetails" :key="index">
                                <legend class="shadow"> {{ cmsData[0].form_left_side_menu_top_text }} </legend>
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>Product Name</label>
                                            <input type="text" v-model="input.productName" class="form-control form-control-sm input_focus rounded-0">
                                            <small class="error"></small>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>Quantity</label>
                                            <input type="number" v-model="input.quantity" class="form-control form-control-sm input_focus rounded-0">
                                            <small class="error"></small>
                                        </div>
                                    </div>
                                    <div class=" col-12 col-md-4">
                                        <div class="form-group">
                                            <label><span>Condition</span></label>
                                            <select v-model="input.condition" class="form-control form-control-sm input_focus rounded-0">
                                                <option value="" selected="selected"></option>
                                                <option value="Brand New">Brand New</option>
                                                <option value="Excellent">Flawless</option>
                                                <option value="Good">Good</option>
                                                <option value="Fair">Fair</option>
                                                <option value="Broken">Broken</option>
                                            </select>
                                            <small class="error"> </small>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>Category</label>
                                            <select v-model="input.category" class="form-control form-control-sm input_focus rounded-0">
                                                <option value="" selected="selected"></option>
                                                <option value="Phone">Phone</option>
                                                <option value="Tablet">Tablet</option>
                                                <option value="Laptop">Laptop</option>
                                                <option value="Desktop">Desktop</option>
                                                <option value="Other">Other</option>
                                            </select>
                                            <small class="error"></small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 text-center">
                                    <button type="button" @click="addProduct(index)" v-show="index == productDetails.length-1" class="btn btn-success"><i class="fa fa-plus"></i> &nbsp; 
                                        Add 
                                    </button>
                                    <button type="button" @click="deleteProduct(index)" v-show="index || (!index && productDetails.length > 1)" class="btn btn-danger"><i class="fas fa-trash"></i> &nbsp; 
                                        Delete
                                    </button>
                                </div>
                            </fieldset>
                        </div>
                        <!-- Upload Specs Sheet -->
                        <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                            <fieldset class="bg-white">
                                <legend class="shadow"> {{ cmsData[0].form_right_side_menu_top_text }} </legend>
                                <div class="row">
                                    <div class="col-12">
                                        <label>
                                            Accepted file types: .doc, .docx, .xls, .xlsx, .pdf<br>
                                            <small class="d-inline-block mb-1">
                                                Maximum file size: 5MB<br>
                                            </small>
                                            <div class="clear"></div>
                                            <input type="hidden" autocomplete="off">
                                            <input type="file" name="specsFile" id="specsFile" @change="onFileChange" ref="inputFile" uploader="uploader" class="w-100">
                                            <small class="error"></small>
                                        </label>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <!-- Upload Specs Sheet -->
                    </div>
                    <!-- Contact Information -->
                    <fieldset class="bg-white">
                        <legend class="shadow"> {{ cmsData[0].contact_form_top_text }} </legend>
                        <div class="row">
                            <div class=" col-12 col-md-6">
                                <div class="form-group">
                                    <label>Name</label>
                                    <input type="text" v-model="name" class="form-control form-control-sm input_focus rounded-0">
                                    <small class="error"></small>
                                </div>
                            </div>
                            <div class=" col-12 col-md-6">
                                <div class="form-group">
                                    <label>Company Name (If Applicable)</label>
                                    <input type="text" v-model="company" class="form-control form-control-sm input_focus rounded-0">
                                    <small class="error"></small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class=" col-12 col-md-6">
                                <div class="form-group">
                                    <label>Email</label>
                                    <input type="email" v-model="email" class="form-control form-control-sm input_focus rounded-0">
                                    <small class="error"></small>
                                </div>
                            </div>
                            <div class="columns col-12 col-md-6">
                                <div class="form-group">
                                    <label>Phone</label>
                                    <input type="text" v-model="phone" class="form-control form-control-sm input_focus rounded-0">
                                    <small class="error"></small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="columns col-12 col-md-6">
                                <div class="form-group">
                                    <label>Additional Comments <em>Not Required</em></label>
                                    <textarea rows="6" v-model="comments" class="form-control form-control-sm input_focus rounded-0"></textarea>
                                    <small class="error"></small>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <!-- Contact Information -->
                    <div class="row">
                        <div class="col-12 text-center">
                            <button type="button" class="btn btn-success" @click="submit"><i class="fas fa-envelope"></i>&nbsp; Submit</button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </section>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "CustomQuoteForm",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            cmsData: [],
            productDetails: [
                {
                    productName: "",
                    quantity: "",
                    condition: "",
                    category: ""
                }
            ],
            input: [],
            name: "",
            company: "",
            email: "",
            phone: "",
            comments: "",
            type: "",
            selectFile: undefined
        }
    },
    created() {
        this.getCustomQuoteCMS();

        let jqueryScript = document.createElement('script')
        jqueryScript.setAttribute('src', '/jquery.min.js')
        document.head.appendChild(jqueryScript)

        let bootstrapScript = document.createElement('script')
        bootstrapScript.setAttribute('src', '/bootstrap.bundle.min.js')
        document.head.appendChild(bootstrapScript)
    },
    methods: {
        addProduct: function(index) {
            this.productDetails.push({ 
                productName: "", 
                quantity: "",
                condition: "",
                category: ""
            });
            console.log(index);
        },
        deleteProduct: function(index) {
            this.productDetails.splice(index, 1);
        },
        onFileChange(event) {
            this.selectFile = event.target.files[0];
        },
        submit: function() {
            this.isLoading = true;
            let selectType = this.type;
            let siteConfig={};
            if(selectType == "uploadFile") {
                const formData = new FormData();
                formData.append("name", this.name);
                formData.append("company", this.company);
                formData.append("email", this.email);
                formData.append("phone", this.phone);
                formData.append("comments", this.comments);
                formData.append("type", this.type);
                formData.append("files", this.selectFile);

                siteConfig = {
                    method: "POST",
                    url: this.$api + this.$config.customQuote.storeCustomQuoteURL,
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                };
            }
            else if(selectType == "formData") {
                const data = {
                    name: this.name,
                    company: this.company,
                    email: this.email,
                    phone: this.phone,
                    comments: this.comments,
                    productDetails: this.productDetails,
                    type: this.type
                };

                siteConfig = {
                    method: "POST",
                    url: this.$api + this.$config.customQuote.storeCustomQuoteURL,
                    data: data
                };
            }
            this.$axios(siteConfig).then((response) => {
                if(response.data.status == "success") {
                    this.$swal.fire({
                        icon: "success",
                        text: "Successfully stored data!"
                    });
                    this.name = '';
                    this.email = '';
                    this.company = '';
                    this.phone = '';
                    this.comments = '';
                    this.productDetails.splice(0);
                    this.$refs.inputFile.value = null;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },

        getCustomQuoteCMS: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + "api/custom-quote-form-cms"
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.cmsData = response.data.data;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        }
    }
}
</script>
